import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-7e1c7451"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-3 py-sm-2 py-md-2 py-lg-2 py-xl-2 bg-dark position-relative" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "lights" }, null, -1))
const _hoisted_3 = { class: "container-xl header-container" }
const _hoisted_4 = { class: "row row-container justify-content-between align-items-center" }
const _hoisted_5 = { class: "col header-item logo-item pe-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "logo",
  src: _imports_0,
  class: "logo"
}, null, -1))
const _hoisted_7 = { class: "col py-1" }
const _hoisted_8 = { class: "row align-items-center" }
const _hoisted_9 = { class: "col header-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"20px"} }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-user" })
  ]),
  /*#__PURE__*/_createElementVNode("i", { class: "fw-semibold fst-normal inscription" }, "Профиль")
], -1))
const _hoisted_11 = { class: "col header-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"20px"} }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-heart" })
], -1))
const _hoisted_13 = { class: "col header-item" }
const _hoisted_14 = {
  style: {"font-size":"20px"},
  class: "position-relative"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-bell" }, null, -1))
const _hoisted_16 = { class: "notification-circle position-absolute translate-middle p-1 rounded-circle" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-success btn-sm search-button px-4",
  type: "submit",
  name: "start_search"
}, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-search text-white" })
  ])
], -1))
const _hoisted_19 = { class: "col header-item slide-menu" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block rounded-3" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block rounded-3" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block rounded-3" }, null, -1))
const _hoisted_23 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MobileAsideComponent = _resolveComponent("MobileAsideComponent")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: {name: 'welcome'} }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("nav", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_router_link, {
                class: "navbar-link text-decoration-none",
                to: {name: 'account'}
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                class: "navbar-link",
                to: {name: 'favorites'}
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_router_link, {
                class: "navbar-link",
                to: "/notifications"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("span", _hoisted_16, null, 512), [
                      [_vShow, _ctx.getNotificationStatus]
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("form", {
                class: "d-flex",
                role: "search",
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.redirectToSearch && _ctx.redirectToSearch(...args)), ["prevent"]))
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control search-field",
                  type: "search",
                  placeholder: "Поиск по названию/автору или тегу",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.value]
                ]),
                _hoisted_18
              ], 32)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: _normalizeClass(["burger-button d-flex flex-column justify-content-center", {open: _ctx.showMobAside}]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleMobileNav()))
              }, _hoisted_23, 2)
            ])
          ])
        ])
      ]),
      _createVNode(_Transition, { name: "slide" }, {
        default: _withCtx(() => [
          (_ctx.showMobAside)
            ? (_openBlock(), _createBlock(_component_MobileAsideComponent, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}